import React from 'react'
import Products from 'api/Products'
import { GroupedShipmentProduct } from 'api/types'
import { Image, SmallTagCounter } from 'components'
import { T, __ } from 'translations/i18n'
import styled from '@emotion/styled'

function ShipmentProductStructure(totalProductsQuantity: number) {
  const ProductImage = styled(Image)`
    object-fit: contain;
    width: 125px;
    height: 100px;
    padding: 10px;
  `
  return [
    {
      label: '',
      width: 140,
      customRender: ({ product }: GroupedShipmentProduct) => (
        <ProductImage style={{ marginTop: 10, marginBottom: 10 }} src={Products.getImageUrl(product.code)} />
      ),
    },
    {
      width: 240,
      label: __(T.misc.upc),
      customValue: ({ product }: GroupedShipmentProduct) => `${product.code}`,
    },
    {
      flex: 2,
      label: __(T.misc.model_part_color_size),
      customValue: ({ product }: GroupedShipmentProduct) =>
        `${product.material?.value ?? '--'} / ${product.style?.value ?? '--'} / ${product.color?.value ?? '--'} / ${
          product.size?.value ?? '--'
        }`,
    },
    {
      label: __(T.misc.quantity, { quantity: totalProductsQuantity }),
      width: 180,
      customRender: (product: GroupedShipmentProduct) => (
        <SmallTagCounter detected={product.detected} unexpected={product.unexpected} expected={product.expected} />
      ),
    },
  ]
}

export default {
  ShipmentProductStructure,
}
